import moment from 'moment';
import { ISelected } from '../common/hierarchy/SearchHierarchy';
import { ITreeItem } from '../common/treeview/TreeItem';
import { ITreeItemParentBinderView } from './types';
import { ILevel } from './useViewer';

export const getTreeItem = (nodeId: string, text: string, child?: ITreeItem[]): ITreeItem => {
  return { nodeId, text, child };
};

export const getTreeItems = (treeitems: ITreeItemParentBinderView[]): ITreeItem[] => {
  const treeviewItems: ITreeItem[] = [];
  for (const first of treeitems) {
    const firstLevel = getTreeItem(first.document_priority.toString(), `${first.zone} ${first.isf_document_type}`, []);
    for (const second of first.isf_document_subtype) {
      const secondLevel = getTreeItem(
        `${first.document_priority} ${second.document_subtype_priority}`,
        `${second.section} ${second.isf_document_subtype}`,
        []
      );
      for (const third of second.isf_artifact) {
        const thirdLevel = getTreeItem(
          `${first.document_priority} ${second.document_subtype_priority} ${third.artifact_priority}`,
          `${third.isf_artifact_number} ${third.isf_artifact_name.replace(/ *\([^)]*\) */g, '')}`
        );
        secondLevel.child?.push(thirdLevel);
      }
      firstLevel.child?.push(secondLevel);
    }
    treeviewItems.push(firstLevel);
  }
  return treeviewItems;
};

export const getParentNodes = (arr: string[]): string[] => {
  return arr.filter(val => val.toString().indexOf(' ') === -1);
};

export const notInArray = (arr1: string[], arr2: string[]): string[] => {
  return arr1.filter(val => !arr2.includes(val));
};

export const formatDate = (value: any, dateFormat: string) => {
  if (value) {
    return moment(new Date(value)).format(dateFormat);
  }
  return;
};

export const getQuery = (level: ILevel, menu: ISelected, from:number,size:number): string => {
  let otherSelection = '';
  if (menu.site) {
    if (level) {
      if (level.secondlevel && level.thirdlevel) {
        otherSelection = `isf_doc_type=${encodeURIComponent(
          level.firstlevel?.isf_document_type
        )}&isf_doc_subtype=${encodeURIComponent(
          level.secondlevel?.isf_document_subtype
        )}&isf_artifact_number=${encodeURIComponent(level.thirdlevel?.isf_artifact_number)}`;
      } else if (level.secondlevel) {
        otherSelection = `isf_doc_type=${encodeURIComponent(
          level.firstlevel?.isf_document_type
        )}&isf_doc_subtype=${encodeURIComponent(level.secondlevel?.isf_document_subtype)}`;
      } else {
        otherSelection = `isf_doc_type=${encodeURIComponent(level.firstlevel?.isf_document_type)}`;
      }
      otherSelection = `?country_id=${menu.country}&site_id=${menu.site}&study_id=${menu.study}&${otherSelection}&isf_doc_level=Site&application=ISF&module_section_related=ISF%20Binder%20Viewer&is_binder_view=false&from=${from}&size=${size}`;
    }
  }
  return otherSelection;
};

export const getLevel = (nodeId: string, data: ITreeItemParentBinderView[] | undefined): ILevel => {
  const [first, second = -1, third = -1] = nodeId.split(' ').map(i => Number(i));
  const firstlevel = data?.find(item => item.document_priority === first);
  const secondlevel = firstlevel?.isf_document_subtype.find(item => item.document_subtype_priority === second);
  const thirdlevel = secondlevel?.isf_artifact.find(item => item.artifact_priority === third);
  return { firstlevel, secondlevel, thirdlevel };
};
